<script setup>
import BlogFooterComponent from "@/components/BlogPost/BlogFooterComponent.vue";
import BlogHeaderComponent from "@/components/BlogPost/BlogHeaderComponent.vue";
import { showToast } from "@/composables/toast";
import { useSessionMessageStore } from "@/stores/sessionMessage";
import { useToast } from "primevue";
import { onMounted, ref, watch } from "vue";
import { RouterView, useRoute } from 'vue-router';

const route = useRoute();
const isBlogPrefix = ref(false);
const messageStore = useSessionMessageStore();
const toast = useToast();

onMounted(() => {
  if (messageStore.hasMessage) {
    showToast(toast, messageStore.getMessageType, messageStore.getMessageType);
    messageStore.cleanMessage();
  }
  handleRoute(route.path);
});

// Checks url change
watch(
  () => route.path,
  (newPath) => {
    handleRoute(newPath);
  }
);

watch(() => messageStore.hasMessage, (hasMessage) => {
  if (hasMessage) {
    showToast(toast, messageStore.message, messageStore.getMessageType);
    messageStore.cleanMessage();
  }
});

/**
 * Checks if route is from /blog
 */
function handleRoute(path) {
  isBlogPrefix.value = path.includes('/blog');
}

</script>

<template>
  <div>
    <BlogHeaderComponent :is-blog-prefix="isBlogPrefix" />

    <section class="mt-5">
      <RouterView />
    </section>

    <BlogFooterComponent />
  </div>
</template>
